import store from '~/store'

export default async (to, from, next) => {
  let userPermissions = await store.getters['permission/userPermissionsAndActionTasks']
  let componentIndex = await to.matched.findIndex((item, index) => {
    if (item.name === to.name) {
      return index
    }
  })

  /* I know It's fucking spaghetti code, but I really don't know how to realize this
   * On the first call, this data is Promise Func, but later it's just a variable
   */
  let component = (componentIndex > 0)
    ? (await to.matched[componentIndex].parent.components.default instanceof Function)
      ? await to.matched[componentIndex].parent.components.default()
      : await to.matched[componentIndex].parent.components.default
    : (await to.matched[componentIndex].components.default instanceof Function)
      ? await to.matched[componentIndex].components.default()
      : await to.matched[componentIndex].components.default

  if (component.metaInfo().title === 'Admin Panel') {
    if (await checkAdmin(userPermissions, component.metaInfo().title)) {
      return next()
    } else {
      return next({ name: 'permission-alert' })
    }
  }

  if (await checkModuleActionDenied(userPermissions, component.metaInfo().title) === false) {
    next()
  } else {
    next({ name: 'permission-alert' })
  }
}

async function checkModuleActionDenied (permissions, moduleName) {
  let permissionName
  for (let permission of permissions) {
    permissionName = permission.app_permission.visible_name
    if (Array.isArray(moduleName.match(permissionName)) === true && permission.app_action_task.name === 'denied') {
      return true
    }
  }
  return false
}

async function checkAdmin (permissions, moduleName) {
  let permissionName
  for (let permission of permissions) {
    permissionName = permission.app_permission.visible_name
    if (permissionName === 'Admin Panel' &&
      Array.isArray(moduleName.match(permissionName)) === true &&
      permission.app_action_task.name === 'admin') {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/check-action-level.js